import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const VCS_INTEGRATION_USED_BY_TABLE_STORAGE_KEY = "vcsIntegrationUsedByTableStorageKey";
export const VCS_INTEGRATION_USED_BY_TABLE_FILTERS_STORAGE_KEY =
  "vcsIntegrationUsedByTableFiltersStorageKey";

export enum VCS_INTEGRATION_USED_BY_COLUMN_ID {
  TYPE = "TYPE",
  NAME = "NAME",
  SPACE = "SPACE",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;
export const ITEMS_LIMIT = 50;

export const VCS_INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG: Record<
  VCS_INTEGRATION_USED_BY_COLUMN_ID,
  TableColumnMeta
> = {
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.TYPE]: {
    id: VCS_INTEGRATION_USED_BY_COLUMN_ID.TYPE,
    title: "Type",
    minWidth: 100,
    defaultWidth: 100,
    maxWidth: 100,
    allowsSorting: true,
    resizable: false,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.NAME]: {
    id: VCS_INTEGRATION_USED_BY_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.SPACE]: {
    id: VCS_INTEGRATION_USED_BY_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: {
    id: VCS_INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN,
    title: "VCS agent pool actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<VCS_INTEGRATION_USED_BY_COLUMN_ID, string> = {
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.TYPE]: "isModule",
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.NAME]: "name",
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.SPACE]: "space",
  [VCS_INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN]: "dropdown",
};
export const INITIAL_SORT_OPTION = SORT_CONFIG[VCS_INTEGRATION_USED_BY_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
